

import React, { useState } from 'react';
import { useEffect } from 'react';
import '../../react-calendar/src/styles.scss'; // main style file
import '../../react-calendar/src/theme/default.scss'; // theme css file
import {Dropdown} from "react-bootstrap";

const VariantSelector = ({variants, variant, onVariantChange}) => {
    if (variants.length === 0) {
        return null;
    }

    const [selectedVariant, setVariant] = useState(variants[0].id);

    useEffect(() => {
        onVariantChange(selectedVariant);

    }, [selectedVariant]);


    const findVariant = (id) => {
        for(var i in variants) {
            if (variants[i].id == id) {
                return variants[i];
            }
        }
        return null;
    }


    let current = findVariant(selectedVariant);

    return (
        <div className='ms-2'>
            <Dropdown>
                <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
                     {selectedVariant ? 'Velikost: ' + current.title  : 'Vyberte variantu'}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {variants.map((variant) => {
                        return <Dropdown.Item key={variant.id} onClick={() => setVariant(variant.id)}>{variant.title}</Dropdown.Item>
                    })}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
}

export default VariantSelector;